import { Navigate, Outlet } from 'react-router-dom';
import { homePathForSession, useAuth } from '@/providers/AuthProvider';

/** Redirect unauthenticated users to login. */
export function RequireAuth() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}

/** Redirect authenticated users away from auth pages. */
export function RedirectIfAuthenticated() {
  const { isAuthenticated, session } = useAuth();

  if (isAuthenticated) {
    return <Navigate to={homePathForSession(session)} replace />;
  }

  return <Outlet />;
}
